// extracted by mini-css-extract-plugin
module.exports = {"wordRadicalContent":"WordRadicalContent_wordRadicalContent__1EtQl","content":"WordRadicalContent_content__2go91"};